import { keyStorage } from "constants/globals";

export interface User {
  access_token: string;
  expires_in: number;
  refresh_expires_in: number;
  refresh_token: string;
  token_type: string;
  "not-before-policy": number;
  session_state: string;
  scope: string;
  userName: string;
}

export const setCurrentUser = (user: User) => {
  sessionStorage.setItem(keyStorage.user, JSON.stringify(user));
};

export const getCurrentUser = (): User | null => {
  const resp = sessionStorage.getItem(keyStorage.user);
  return resp ? JSON.parse(resp) : null;
};

export const logoutUser = () => {
  sessionStorage.removeItem("user");
};
